export default __webpack_public_path__ + "static/backgroundArchive--blurV-a0c440c93ecae58cdbd756b7e1677f0f.jpg";